import { useState } from 'react';

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const navItems = [
    { href: '#ranking', label: '热门榜单' },
    { href: '#topics', label: '热门话题' },
    { href: '#media', label: '精彩预告' },
    { href: '#about', label: '关于我们' },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 h-16 flex items-center transition-all duration-300 bg-background-50/95 backdrop-blur-md border-b border-background-200/60">
      <div className="w-full px-4 md:px-6 flex items-center justify-between">
        <a href="#" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
          <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
            <i className="ri-film-line text-lg text-background-50"></i>
          </span>
          <span className="text-lg font-bold font-heading text-foreground-50">萝卜影视</span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          <a href="#" className="px-4 py-2 text-sm font-medium text-foreground-200 hover:text-primary-400 transition-colors rounded-lg whitespace-nowrap cursor-pointer">
            首页
          </a>
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="px-4 py-2 text-sm font-medium text-foreground-300 hover:text-primary-400 transition-colors rounded-lg whitespace-nowrap cursor-pointer"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-200 hover:text-primary-400 transition-colors cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {menuOpen && (
        <nav className="md:hidden absolute top-16 left-0 right-0 bg-background-100/98 backdrop-blur-md border-b border-background-200/60 py-3 px-4 flex flex-col gap-1">
          <a
            href="#"
            className="px-4 py-3 text-sm font-medium text-foreground-200 hover:text-primary-400 hover:bg-background-200/50 rounded-lg whitespace-nowrap cursor-pointer"
            onClick={() => setMenuOpen(false)}
          >
            首页
          </a>
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="px-4 py-3 text-sm font-medium text-foreground-300 hover:text-primary-400 hover:bg-background-200/50 rounded-lg whitespace-nowrap cursor-pointer"
              onClick={() => setMenuOpen(false)}
            >
              {item.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
}